import React from 'react';
import left from 'image/arrow-left.png';

// Meme rendu visuel que utils/HeaderFirst, mais le bouton "Retour"
// appelle onBack (navigation interne de la page) au lieu de navigate(-1).
export default function FacturationHeader({ nom, description, onBack }) {
  return (
    <div className="header-title" style={{ padding: '15px', flex: 1 }}>
      <div
        style={{ cursor: 'pointer', width: 'fit-content' }}
        onClick={onBack}
      >
        <img
          src={left}
          className="imageLeft"
          style={{ width: '10px', height: '14px' }}
          alt="Retour"
        />
        <span style={cardStyle} className="mx-2">
          Retour
        </span>
      </div>
      <div style={solde}>{nom}</div>
      <span style={text}>{description}</span>
    </div>
  );
}

const cardStyle = {
  color: '#009688',
  fontWeight: '700',
  fontSize: '15px',
  fontFamily: 'Montserrat',
};

const solde = {
  fontFamily: 'Montserrat',
  fontSize: '35px',
  fontWeight: '600',
  marginTop: '10px',
};

const text = {
  fontFamily: 'Montserrat',
  fontWeight: '400',
  fontSize: '13px',
};
